export default __webpack_public_path__ + "static/media/project-fastest.14ea9abb.jpg";